import { forwardRef } from "react";
import { TypographyProps } from "@flash-tecnologia/hros-web-ui-v2";
import * as SC from "./title.styles";
import { Optional } from "@/shared/types";

export type TitleProps = Optional<TypographyProps, "variant">;

export const Title = forwardRef<HTMLElement, TitleProps>(
  ({ variant = "headline9", ...props }, ref) => {
    return <SC.EllipsisTitle ref={ref} variant={variant} {...props} />;
  }
);

Title.displayName = "Focused.Header.Title";
